import { inspect } from 'node:util';
import { validateBaseMessage } from '#environment/index.js';
import MessageDescriptor from './MessageDescriptor.js';
export class BaseMessage {
    constructor(_error) {
    }
    static create(data) {
        const instance = new this();
        const messageDescriptor = MessageDescriptor.load(this);
        Object.entries(messageDescriptor.fieldsMetadata).forEach(([key, field]) => {
            const value = key in data
                ? field.fromJSON(data[key])
                : undefined;
            if (value !== undefined) {
                instance[key] = value;
            }
            else if (instance[key] === undefined) {
                delete instance[key];
            }
        });
        return instance;
    }
    static validateAndCreate(data) {
        const messageDescriptor = MessageDescriptor.load(this);
        const validationErrors = validateBaseMessage(messageDescriptor, data);
        if (validationErrors) {
            return { success: false, errors: validationErrors };
        }
        return { success: true, instance: this.create(data) };
    }
    static fromProto(data) {
        const instance = new this();
        const messageDescriptor = MessageDescriptor.load(this);
        Object.entries(messageDescriptor.fieldsMetadata).forEach(([key, field]) => {
            const value = key in data
                ? field.fromProto(data[key])
                : undefined;
            if (value !== undefined) {
                instance[key] = value;
            }
            else if (instance[key] === undefined) {
                delete instance[key];
            }
        });
        return instance;
    }
    assign(key, val) {
        const messageDescriptor = MessageDescriptor.load(this);
        const field = messageDescriptor.fieldsMetadata[key];
        const value = field.fromJSON(val);
        if (value !== undefined) {
            this[key] = value;
        }
        return this;
    }
    equals(record) {
        const a = this;
        const b = record;
        const messageDescriptor = MessageDescriptor.load(this);
        return Object.keys(messageDescriptor.fieldsMetadata).every((key) => {
            const valueA = a[key];
            const valueB = b[key];
            if (valueA && typeof valueA.equals === 'function') {
                if (!valueA.equals(valueB)) {
                    return false;
                }
            }
            else if (valueA && typeof valueA.valueOf === 'function') {
                if (valueA.valueOf() !== valueB.valueOf()) {
                    return false;
                }
            }
            else if (valueA !== valueB) {
                return false;
            }
            return true;
        });
    }
    copy(patch) {
        const data = Object.assign({}, structuredClone(this), patch);
        const prototype = Object.getPrototypeOf(this);
        return prototype.constructor.create(data);
    }
    toJSON(target) {
        const messageDescriptor = MessageDescriptor.load(this);
        return Object.entries(messageDescriptor.fieldsMetadata).reduce((result, [key, field]) => {
            const value = this[key];
            if (target === "LOG" && !field.log) {
                result[key] = '__HIDDEN__';
            }
            else if (value !== undefined) {
                result[key] = field.toJSON(value, target);
            }
            return result;
        }, {});
    }
    inspect(options = {}) {
        return inspect(this, {
            colors: true,
            depth: Infinity,
            getters: true,
            ...options,
        });
    }
    static isInstance(item) {
        return item instanceof this;
    }
}
//# sourceMappingURL=BaseMessage.js.map